import React from 'react';
import ContentLoader from 'react-content-loader';
var ItemSkeletonMobile = function ItemSkeletonMobile() {
  var skeletons = [];
  for (var index = 0; index < 12; index++) {
    skeletons.push(/*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(ContentLoader, {
      speed: 1,
      width: '100%',
      height: 323,
      viewBox: "0 0 auto 310",
      backgroundColor: "#f3f3f3",
      foregroundColor: "#ecebeb",
      style: {
        background: 'white',
        marginTop: '16px'
      }
    }, /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "8",
      rx: "3",
      ry: "3",
      width: "90",
      height: "32"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "48",
      rx: "3",
      ry: "3",
      width: "95%",
      height: "8"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "64",
      cy: "129",
      r: "48"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "126",
      y: "105",
      rx: "3",
      ry: "3",
      width: "200",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "210",
      rx: "3",
      ry: "3",
      width: "80%",
      height: "7"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "126",
      y: "135",
      rx: "3",
      ry: "3",
      width: "150",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "190",
      rx: "3",
      ry: "3",
      width: "60%",
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "481",
      y: "373",
      rx: "0",
      ry: "0",
      width: "1",
      height: "0"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "230",
      rx: "3",
      ry: "3",
      width: "30",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "246",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "16",
      y: "270",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "104",
      y: "226",
      rx: "3",
      ry: "3",
      width: "30",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "104",
      y: "246",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "104",
      y: "270",
      rx: "3",
      ry: "3",
      width: "78",
      height: "6"
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, skeletons);
};
export default ItemSkeletonMobile;